<template>
  <div class="contact page">
    <div class="content">
      <p>email me: <a href="mailto:dewhite@whiteside.in.ua">dewhite@whiteside.in.ua</a></p>
      <p>or text: <a href="https://www.facebook.com/sash.whiteside">fb.com/sash.whiteside</a></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Contact'
  }
</script>

<style lang="scss" scoped>
  .content {
    padding: 30px;
    font-family: $font-title;
    font-size: 20px;
    p {
      padding: 2px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue